'use client';

import classNames from 'classnames';
import { type PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

import { useMounted } from '@shared/utils';

import styles from './tooltip.module.scss';

export const TooltipTrigger = ({
  children,
  className,
  id,
  tooltip,
}: PropsWithChildren<{
  className?: string;
  id: string;
  tooltip: string;
}>) => {
  const isMounted = useMounted();

  return (
    <>
      <button
        aria-label={tooltip}
        className={classNames(styles['tooltip-trigger'], className)}
        data-tooltip-content={tooltip}
        data-tooltip-id={id}
        tabIndex={0}
      >
        {children}
      </button>
      {isMounted
        ? createPortal(<Tooltip className={styles['tooltip']} id={id} place="top" />, document.body)
        : null}
    </>
  );
};
